import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'aid-options-menu-title',
  template: `
    <div
      class="mat-headline-6 padding-horizontal-32 padding-vertical-16 aid-layout-row aid-layout-align-start-center aid-layout-gap-16"
    >
      <ng-content select="[aidGoBack]"></ng-content>
      <div
        class="full-width aid-layout-row aid-layout-align-space-between-center"
      >
        @if (sentencecase) {
          <span>
            {{ title | translate | sentancecase }}
          </span>
        }
        @if (!sentencecase) {
          <span>
            {{ title | translate }}
          </span>
        }
        <ng-content select="[aidViewButtons]"></ng-content>
      </div>
    </div>
    <mat-divider></mat-divider>
  `,
  styleUrls: ['./options-menu-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class OptionsMenuTitleComponent implements OnInit {
  @Input() title?: string;
  @Input() sentencecase = true;

  constructor() {}

  ngOnInit() {}
}
